import * as React from "react";
import {connect, Dispatch} from "react-redux";
import AcquisitionChannel from "../../../model/acquisitionChannel/AcquisitionChannel";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {RootState} from "../../../store/reducer/root/RootState";
import {
	createAcquisitionChannel,
	updateAcquisitionChannel,
	updateAcquisitionChannelSortOrder
} from "../../../store/action/acquisitionChannel/acquisitionChannel";
import DictionarySortableItemsList from "../common/DictionarySortableItemsList";


interface ReduxProps {
	/**
	 * All acquisition channels.
	 */
	acquisitionChannels: AcquisitionChannel[];
}


interface DispatchProps {
	/**
	 * Sort order update callback.
	 * @param {string} acquisitionChannelId
	 * @param {number} sortOrder
	 */
	updateSortOrder: (acquisitionChannels: AcquisitionChannel[], onSuccess: OnSuccess, onFailure: OnFailure) => any;
	/**
	 * Create acquisition channel.
	 * @param {string} name
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createAcquisitionChannel: (acquisitionChannel: AcquisitionChannel, onSuccess: OnSuccess, onFailure: OnFailure) => any;
	/**
	 * Update acquisition channel.
	 * @param {string} name
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateAcquisitionChannel: (acId: string,
		acquisitionChannel: AcquisitionChannel,
		onSuccess: OnSuccess,
		onFailure: OnFailure) => any;
}

type Props = ReduxProps & DispatchProps;

/**
 * Lead acquisition channel config view.
 */
class AcquisitionChannelConfigView extends React.Component<Props, {}> {

	render() {
		return (
			<DictionarySortableItemsList title={"Acquisition Channel"}
										 items={this.props.acquisitionChannels}
										 updateItem={this.props.updateAcquisitionChannel}
										 createItem={this.props.createAcquisitionChannel}
										 updateSortOrder={this.props.updateSortOrder}/>
		)
	}

}

function mapStateToProps(state: RootState) {
	return {
		acquisitionChannels: [].concat(state.acquisitionChannel.acquisitionChannels.getOrElse([]))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateSortOrder: (acquisitionChannels: AcquisitionChannel[], onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateAcquisitionChannelSortOrder(acquisitionChannels, onSuccess, onFailure)
		),
		createAcquisitionChannel: (acquisitionChannel: AcquisitionChannel, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createAcquisitionChannel(acquisitionChannel, onSuccess, onFailure)),
		updateAcquisitionChannel: (acId: string,
			acquisitionChannel: AcquisitionChannel,
			onSuccess: OnSuccess,
			onFailure: OnFailure) =>
			dispatch(updateAcquisitionChannel(acId, acquisitionChannel, onSuccess, onFailure))
	}
}

export default connect<ReduxProps, DispatchProps, null>(mapStateToProps, mapDispatchToProps)(AcquisitionChannelConfigView)